import "./loadingProgress.scss";
import { ProgressBar } from "react-bootstrap";

export default function LoadingProgress({ isLoading, progress }) {
  if (!isLoading) return null;

  return (
    <div className="loadingWrap position-fixed w-100 h-100 align-items-center justify-content-center d-flex">
      <div className="loadingWrapper text-center" style={{ width: "50vw" }}>
        <img
          src="../../../public/images/sysManage/loading.gif"
          alt="loading"
          className="mb-3"
        />
        <ProgressBar
          now={progress}
          label={`${progress}%`}
          style={{ height: "1.5rem" }}
        />
      </div>
    </div>
  );
}
